{
  "title": "AirPlx",
  "message": "Estamos realizando mantenimiento programado. AirPlx estará disponible nuevamente a las {{endTime}}."
}
